<template>
  <div
    class="rounded-l-full max-w-md w-full lg:flex bg-white mt-4 mb-5 transition relative z-10 "
    @click="goToMenu(classe)"
  >
    <div class=" flex flex-col justify-between leading-normal relative z-2">
      <div class="flex items-center">
        <img
          class="rounded-full mr-4 h-100 w-100 -mb-2 -mt-1"
          src="img/classe.jpg"
        >
        <div>
          <h3 class="text-grey-dark ">{{ classe.class_name }}</h3>
          <p class="text-grey ">{{$t('all.kids_number')}}: {{ classe.total_children }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: ['classe'],
  methods: {
    ...mapActions('classi', ['setSelectedClass']),
    goToMenu(classe) {
      this.setSelectedClass(classe);
    },
  },
};
</script>
